<span>{{title}}</span>
<span class='error' [matTooltip]='error|async'>{{error|async}}</span>
<div class='status' [style.backgroundColor]='bgColor'>{{status|async}}</div>
<button mat-icon-button (click)='refresh.emit()'>
  <mat-icon>refresh</mat-icon>
</button>
